export const initChartData = {
    labels: [],
    datasets: [
        {
            borderWidth: 1,
            type: "line",
            label: "slingshot1",
            data: [],
            borderColor: "orange",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "orange"

            // tension: 0.4
        },
        {
            borderWidth: 1,
            type: "line",
            label: "slingshot2",
            data: [],
            borderColor: "purple",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "purple"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "moving_average1",
            data: [],
            borderColor: "#000",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#000"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "moving_average2",
            data: [],
            borderColor: "#41626C",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#41626C"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "moving_average3",
            data: [],
            borderColor: "#2FF2B5",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#2FF2B5"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "moving_average4",
            data: [],
            borderColor: "yellow",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "yellow"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "moving_average5",
            data: [],
            borderColor: "#F59E89",
            lineTension: 0.2,
            yAxisID: "y2",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#F59E89"
        },

        {
            borderWidth: 1,
            label: "Main Renko",
            type: "bar",
            data: [],
            backgroundColor: [],
            stack: "combined",
            yAxisID: "y2",
            barPercentage: 1,
            categoryPercentage: 1,
            order: 4
            // barThickness: 26
        },
        {
            borderWidth: 1,
            label: "Sub Renko",
            type: "bar",
            data: [],
            backgroundColor: [],
            stack: "combined",
            yAxisID: "y2",
            barPercentage: 1,
            categoryPercentage: 1,
            order: 4

            // barThickness: 26
        },
        {
            borderWidth: 1,
            type: "line",
            label: "Wave Trend 1",
            data: [],
            borderColor: "#26A69A",
            lineTension: 0.2,
            yAxisID: "y1",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#26A69A"
        },
        {
            borderWidth: 1,
            type: "line",
            label: "Wave Trend 2",
            data: [],
            borderColor: "#EF5350",
            lineTension: 0.2,
            yAxisID: "y1",
            hidden: true,
            order: 1,
            pointStyle: "circle",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointBackgroundColor: "#EF5350"
        }

        // {
        //     type: "line",
        //     label: "profit",
        //     data: positionStatus?.map((ps) => ps?.profit),
        //     borderColor: "pink",
        //     lineTension: 0.2,
        //     yAxisID: "y1"
        // },
        // {
        //     type: "line",
        //     label: "total_profit",
        //     data: positionStatus?.map((ps) => ps?.total_profit),
        //     borderColor: "red",
        //     lineTension: 0.2,
        //     yAxisID: "y1"
        // }
    ]
};

export const initOptions = {
    maintainAspectRatio: true,
    animations: false,
    responsive: true,
    maintainAspectRatio: true,
    // aspectRatio: window.innerWidth > 480 ? 1 : 2,
    elements: {
        // point:{
        //     radius:0
        // }
    },
    layout: {
        padding: 18
    },
    plugins: {
        legend: {
            fullSize: true,
            // display: false
            labels: {
                pointStyle: "rectRounded",
                usePointStyle: true
            }
        },
        zoom: {
            zoom: {
                wheel: {
                    enabled: true
                },
                pinch: {
                    enabled: true
                }
            },
            pan: {
                enabled: true
            }
        }
    },
    animation: false,
    // showLine: false,
    scales: {
        x: {
            // stacked: 'single',
            grid: {
                display: false
            },

            beginAtZero: false
        },
        y: {
            type: "linear",
            display: false,
            // position: "left",
            grid: {
                display: false
            }
        },
        y2: {
            type: "linear",
            display: true,
            position: "left",
            grid: {
                display: false
            }
        },

        y1: {
            grid: {
                display: false
            },
            type: "linear",
            display: true,
            position: "right"
        }
    }
};
